<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()
const { imageAdditionalDetails } = usePrepareDetailsCarData(
  computed(() => props.details),
)
</script>

<template>
  <tr v-if="imageAdditionalDetails.display">
    <td>
      <table class="w-full border-collapse">
        <thead>
          <SectionsDetailsPdfElementsHeading as="th">
            {{ imageAdditionalDetails.title }}
          </SectionsDetailsPdfElementsHeading>
        </thead>
        <tbody>
          <tr>
            <td>
              <SectionsDetailsPdfElementsImages
                :images="details.imageAdditionalDetails"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>
